module.exports = __webpack_public_path__ + "img/data_ni.0fcbd1ee.jpeg";